import { Icon } from '~/components';
import { cn } from '~/lib/cn';

interface MaintenanceDisplayProps {
  pageTitle: string;
  title: string;
  description?: string;
  className?: string;
}

function MaintenanceDisplay({
  pageTitle,
  title,
  description,
  className,
}: MaintenanceDisplayProps): React.ReactNode {
  return (
    <>
      <h2 className="m-xl mt-2xl border-b pb-lg text-display-md font-bold border-emphasis-subtle">
        {pageTitle}
      </h2>

      <div
        data-testid="maintenance-display"
        className={cn(
          'flex items-center justify-center rounded-xs border border-dashed bg-level-01 border-emphasis-subtle',
          className,
        )}
      >
        <div className="items-center text-center">
          <p className="text-body-md">
            <Icon type="wrench" variant="light" size="4x" />
          </p>
          <p className="mb-sm mt-lg text-headline-md font-semibold text-default">
            {title}
          </p>
          {description ? (
            <p className="text-body-md text-subtle">{description}</p>
          ) : null}
        </div>
      </div>
    </>
  );
}

MaintenanceDisplay.displayName = 'MaintenanceDisplay';

export { MaintenanceDisplay };
